import { render, staticRenderFns } from "./VPNPoolList.vue?vue&type=template&id=19b99862&"
import script from "./VPNPoolList.vue?vue&type=script&lang=js&"
export * from "./VPNPoolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports